//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        modalName: {
            default: null
        }
    },
    data: function data() {
        return {
            showSlideout: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        Event.$on('open-slide', function (modalName) {
            // Adds ability to open a specific modal identified in modalName
            if (modalName && modalName === _this.modalName || !modalName && !_this.modalName) {
                $el.showSlideout = true;
            }
        });

        Event.$on('close-slide', function () {
            var modalName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (modalName && modalName === _this.modalName || !modalName && !_this.modalName) {
                $el.showSlideout = false;
            }
        });
    },

    methods: {
        closeSlideOut: function closeSlideOut() {
            Event.$emit('close-slide');
            this.showSlideout = false;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/ResidentSlideOut.vue
// module id = fHFi
// module chunks = 0 1